<template>
  <div class="widget-wrapper h-100" :style="rootStyle">
    <div class="widget-wrapper__header">
      <h2 class="widget-wrapper__title" :title="title">{{ title }}</h2>
      <div class="widget-wrapper__actions">
        <button type="button" class="btn btn-sm btn-link p-0" title="Settings" @click.stop="$emit('settings')">
          <i class="fas fa-cog"></i>
        </button>
        <button
          v-if="editMode"
          type="button"
          class="btn btn-sm btn-link text-danger p-0"
          title="Remove"
          @click.stop="$emit('remove')"
        >
          <i class="fas fa-times"></i>
        </button>
      </div>
    </div>
    <div class="widget-wrapper__body" :class="{ 'widget-wrapper__body--edit': editMode, 'widget-wrapper__body--flush': flush }">
      <slot />
    </div>
  </div>
</template>

<script>
import { appearanceStyle } from '@/widgets/appearance'

export default {
  props: {
    title: { type: String, default: 'Widget' },
    editMode: { type: Boolean, default: false },
    flush: { type: Boolean, default: false },
    config: { type: Object, default: () => ({}) },
  },
  computed: {
    rootStyle() {
      return appearanceStyle(this.config)
    },
  },
}
</script>

<style scoped>
.widget-wrapper {
  background: var(--ws-widget-bg);
  border: 1px solid var(--ws-widget-border);
  color: var(--ws-text);
  border-radius: 6px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.widget-wrapper__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  padding: 0.55rem 0.75rem 0.45rem;
  background: var(--ws-widget-header-bg);
  border-bottom: 1px solid var(--ws-widget-border);
  flex-shrink: 0;
  cursor: default;
}
.is-editing .widget-wrapper__header,
.widget-wrapper__header {
  cursor: grab;
}
.widget-wrapper__title {
  margin: 0;
  flex: 1;
  min-width: 0;
  font-size: 0.9375rem;
  font-weight: 700;
  line-height: 1.25;
  color: var(--ws-text);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.widget-wrapper__actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
  cursor: default;
}
.widget-wrapper__actions .btn {
  min-width: 28px;
  min-height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.widget-wrapper__body {
  flex: 1;
  overflow: auto;
  padding: 0.75rem;
  color: var(--ws-text);
  font-size: var(--ws-content-font-size, 14px);
  --ws-font-size: var(--ws-content-font-size, 14px);
  --ws-display-size: var(--ws-content-display-size, 32px);
  min-height: 0;
  display: flex;
  flex-direction: column;
  -webkit-overflow-scrolling: touch;
}
.widget-wrapper__body--flush {
  padding: 0;
  overflow: hidden;
}
.widget-wrapper__body--edit {
  user-select: none;
  pointer-events: none;
}
</style>
